<div class="cell auto" *ngIf="parameters">
    <form insurancesParametersForm="ngForm">
        <kiwi-parameters-tab-content-header [titleLabelKey]="'parameters.financial.insurances.title'"
                                            [saveDisabled]="areParametersReadonly()"
                                            (saved)="updateParameters()">
        </kiwi-parameters-tab-content-header>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <p [i18nKey]="'parameters.financial.insurances.description'"></p>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <table class="_tableColor">
            <tbody>
            <tr>
                <td [i18nKey]="'parameters.financial.insurances.liability.insurance.cost'"></td>
                <td>
                    <kiwi-currency-input [(ngModel)]="parameters.liabilityInsuranceCost"
                                         name="liabilityInsuranceCost"
                                         [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.financial.insurances.property.insurance.cost'"></td>
                <td>
                    <kiwi-currency-input [(ngModel)]="parameters.propertyInsuranceCost"
                                         name="propertyInsuranceCost"
                                         [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.financial.insurances.operating.loss.insurance.cost'"></td>
                <td>
                    <kiwi-currency-input [(ngModel)]="parameters.operatingLossInsuranceCost"
                                         name="operatingLossInsuranceCost"
                                         [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
            </tr>
            <tr>
                <td [i18nKey]="'parameters.financial.insurances.discount'"></td>
                <td>
                    <kiwi-currency-input [(ngModel)]="parameters.discount"
                                         name="discount"
                                         [disabled]="areParametersReadonly()">
                    </kiwi-currency-input>
                </td>
            </tr>
            </tbody>
        </table>
    </form>
</div>
